module.exports = {"640521100":"宁安镇","640521101":"鸣沙镇","640521102":"石空镇","640521103":"新堡镇","640521104":"恩和镇","640521105":"大战场镇","640521200":"舟塔乡","640521201":"白马乡","640521202":"余丁乡","640521204":"喊叫水乡","640521205":"徐套乡","640521206":"太阳梁乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640521.json
// module id = 3046
// module chunks = 0